<template>
  <div id="app">
    <div class="page">
      <header class="header">
        <div class="grid-container">
          <div class="grid-x grid-padding-x">
            <div class="small-12 cell text-center">
              <a href="./index.html">
                <img src="./assets/logo.png" srcset="./assets/logo@2x.png 2x" width="880" class="logo" alt="Fidelidade ímpar" />
              </a>
            </div>
          </div>
        </div>
      </header>

      <main id="main">
        <section class="heroshot position-relative">
          <div class="img-dog">
            <img src="./assets/dog.svg" width="220" height="280" alt="logo" />
          </div>
          <div class="grid-container full-height">
            <div class="grid-x grid-padding-x full-height">
              <div class="small-12 large-7 full-height position-relative">
                <img src="./assets/dog.svg" width="220" height="280" class="dog-mobile" />
                <img src="./assets/img-hero-mobile.jpg" srcset="./assets/img-hero-mobile@2x.jpg 2x" class="hero-mobile-img">
                <div class="heroshot__content">
                  <div>
                    <h1 class="heroshot__title">SEGURO AUTOMÓVEL</h1>
                    <p class="heroshot__text">Rapidez e eficiência na regularização dos sinistros.</p>
                    <!-- h2 class="heroshot__subtitle">
                      Rapidez e eficiência na regularização dos sinistros.
                    </h2 -->
                    <img src="./assets/discount.png" srcset="./assets/discount@2x.png 2x" class="img-discount" alt="10% desconto">
                  </div>
                </div>
              </div>
              <div class="small-12 large-5 full-height">
                <lead-store-component></lead-store-component>
              </div>
            </div>
          </div>
        </section>
        <section class="intro">
          <div class="grid-container">
            <div class="grid-x grid-padding-x align-center">
              <div class="small-11 large-10 cell text-center">
                <div class="boxes">
                  <div class="box">
                    <img src="./assets/icon-1.svg" width="74" height="118" alt="LINHA GRÁTIS PARA ASSISTÊNCIA" />
                    <h3 class="box__title text-uppercase">LINHA GRÁTIS PARA ASSISTÊNCIA</h3>
                  </div>
                  <div class="box">
                    <img src="./assets/icon-2.svg" width="116" height="118" alt="REBOQUE PARA A VIATURA" />
                    <h3 class="box__title text-uppercase">REBOQUE PARA A VIATURA</h3>
                  </div>
                  <div class="box">
                    <img src="./assets/icon-3.svg" width="115" height="118" alt="TRANSPORTE PARA PASSAGEIROS" />
                    <h3 class="box__title text-uppercase">TRANSPORTE PARA PASSAGEIROS</h3>
                  </div>
                  <div class="box">
                    <img src="./assets/icon-4.svg" width="72" height="118" alt="PARTICIPAÇÃO DO SINISTRO VIA APP" />
                    <h3 class="box__title text-uppercase">PARTICIPAÇÃO DO SINISTRO VIA APP</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-container">
            <div class="grid-x grid-padding-x align-center">
              <div class="small-11 large-8 cell text-center">
                <h2 class="intro__title intro__title--primary text-uppercase">RECEBA UMA COTAÇÃO E SAIBA JÁ QUANTO VAI PAGAR PELO SEU SEGURO AUTOMÓVEL.</h2>
                <a href="#form" id="btn-simule-a" class="btn btn--cta">Quero uma cotação</a>
              </div>
            </div>
          </div>
        </section>
        <section class="info">
          <div class="grid-container info__row">
            <div class="grid-x grid-padding-x align-center align-middle">
              <div class="small-12 medium-6 cell text-center large-5 large-offset-1 large-order-1">
                <img src="./assets/img-intro1.jpg" srcset="./assets/img-intro1@2x.jpg 2x" width="734" height="397" class="info__img" alt="Totalmente online e facilidade de pagamento" />
              </div>
              <div class="small-11 medium-6 cell">
                <div class="info__item">
                  <div class="info__title text-uppercase">MAIS TECNOLOGIA</div>
                  <div class="info__text">Facilidade de participação de sinistro via (APP/e-mail/agência/mediador).</div>
                </div>
                <div class="info__item">
                  <div class="info__title text-uppercase">MAIS ATENDIMENTO</div>
                  <div class="info__text">Facilidade de contacto através dos nossos canais de atendimento (linha grátis e agências).</div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-container info__row">
            <div class="grid-x grid-padding-x align-center align-middle">
              <div class="small-12 medium-6 large-5 cell text-center">
                <img src="./assets/img-intro2.jpg" srcset="./assets/img-intro2@2x.jpg 2x" width="734" height="397" class="info__img" alt="Totalmente online e facilidade de pagamento" />
              </div>
              <div class="small-11 medium-6 large-6 large-offset-1 larger-order-1 cell">
                <div class="info__item">
                  <div class="info__title text-uppercase">MAIS PRÁTICO</div>
                  <div class="info__text">
                    Em caso de sinistro, o cliente só tem que escolher a oficina onde pretende reparar a viatura.<br />
                    Somos a única seguradora que não solicita cotações, para o processo de reparação.
                  </div>
                </div>
                <div class="info__item">
                  <div class="info__title text-uppercase">MAIS SIMPLICIDADE</div>
                  <div class="info__text">Rapidez e eficiência na resolução do processo do sinistro.</div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-container">
            <div class="grid-x grid-padding-x align-center">
              <div class="small-11 large-8 cell text-center">
                <a href="#form" id="btn-simule-b" class="btn btn--cta">Quero uma cotação</a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <footer class="footer">
        <div class="footer__bottom">
          <div class="grid-container">
            <div class="grid-x grid-padding-x">
              <div class="small-12 large-8 cell">
                <div class="logo-link">
                  <a href="https://fidelidadeimpar.co.mz" target="_blank" class="site-link">fidelidadeimpar.co.mz</a>
                  <ul class="socials">
                    <li class="socials__item">
                      <a href="https://www.facebook.com/FidelidadeSeguros.Mocambique/" target="_blank" class="socials__btn">
                        <img src="./assets/icon-facebook.svg" width="30" height="30" class="facebook_icon" alt="Facebook" />
                      </a>
                    </li>
                    <li class="socials__item">
                      <a href="https://www.instagram.com/segurosfidelidadeimpar/" target="_blank" class="socials__btn">
                        <img src="./assets/icon-instagram.svg" width="30" height="30" class="instagram_icon" alt="Instagram" />
                      </a>
                    </li>
                    <li class="socials__item">
                      <a href="https://www.linkedin.com/company/fidelidade-mocambique/" target="_blank" class="socials__btn">
                        <img src="./assets/icon-linkedin.svg" width="30" height="30" class="linkedin_icon" alt="Linkedin" />
                      </a>
                    </li>
                    <li class="socials__item">
                      <a href="https://www.youtube.com/channel/UCJbUowjUKzN7XYNHuB7Solw" target="_blank" class="socials__btn">
                        <img src="./assets/icon-youtube.svg" width="30" height="30" class="youtube_icon" alt="Youtube" />
                      </a>
                    </li>
                    <li class="socials__item">
                      <a href="https://api.whatsapp.com/send?phone=258843207925" target="_blank" class="socials__btn">
                        <img src="./assets/icon-whatsapp.svg" width="30" height="30" class="whatsapp_icon" alt="WhatsApp" />
                        <span>84 320 7925</span>
                      </a>
                    </li>
                  </ul>
                </div>
                <p class="footer__text">
                  Esta informação não dispensa a consulta da informação pré-contrato e contratual legalmente exigida.<br /><br />
                  <strong>FIDELIDADE IMPAR</strong><br />
                  Sede: Rua de Kassuende, n.º 210, piso 19, Bairro Polana Cimento A, Maputo, Maputo, Moçambique.
                </p>
              </div>
              <div class="small-12 large-4 cell">
                <div class="call">
                  LIGUE GRÁTIS<br />
                  <a href="tel:+258800800088"><span>800 800 088</span></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div class="fixed-bar">
        <div class="grid-container">
          <div class="grid-x grid-padding-x align-center align-middle">
            <div class="small-12 cell">
              <div class="fixed-bar__actions">
                <h2 class="fixed-bar__text text-uppercase"><strong>SOLICITE UMA COTAÇÃO PARA O SEU SEGURO AUTOMÓVEL.</strong></h2>
                <a href="#form" class="btn btn--white" data-open="contactModal" id="btnLSOpenFhome" aria-controls="contactModal" aria-haspopup="true" tabindex="0">FALE CONNOSCO</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeadStoreComponent from "./components/LeadStore/LeadStoreComponent.vue";

function getParameterByName(name) {
  name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  var results = regex.exec(location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

export default {
  name: "App",
  components: {
    LeadStoreComponent,
  },
  data() {
    return {
      utm_campaign: null,
      utm_source: null,
      utm_medium: null,
      utm_content: null,
      utm_term: null,
      initialUrl: "https://fidelidadeimpar.co.mz",
    };
  },
  methods: {
    generateURL() {
      var baseURL = "https://fidelidadeimpar.co.mz" + "?utm_campaign=" + this.utm_campaign;
      if (this.utm_source) {
        baseURL = baseURL + "&utm_source=" + this.utm_source;
      }
      if (this.utm_medium) {
        baseURL = baseURL + "&utm_medium=" + this.utm_medium;
      }
      if (this.utm_content) {
        baseURL = baseURL + "&utm_content=" + this.utm_content;
      }
      if (this.utm_term) {
        baseURL = baseURL + "&utm_term=" + this.utm_term;
      }
      return baseURL;
    },
  },
  created() {
    this.utm_campaign = getParameterByName("utm_campaign");
    this.utm_source = getParameterByName("utm_source");
    this.utm_medium = getParameterByName("utm_medium");
    this.utm_content = getParameterByName("utm_content");
    this.utm_term = getParameterByName("utm_term");
    if (this.utm_campaign) {
      this.link_one = this.generateURL();
    } else {
      this.link_one = this.initialUrl;
    }
  },
};
</script>

<style lang="scss">
@import "./styles/app.scss";
@import "./components/LeadStore/style/leadstore.scss";
</style>
